import { useQuery } from 'react-query';

import { getAllTrapsActivityBartChartData } from 'api/analitics/MCTCharts/1_getAllTrapsActivityBarChart';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetAllTrapsActivity = (
  slug: string,
  period: string,
  startDate: string,
  endDate: string,
  trap_type: TrapType,
  enabled?: boolean,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'allTrapsActivityBartChartData',
    () => getAllTrapsActivityBartChartData(slug, period, startDate, endDate, trap_type),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetAllTrapsActivity;
